export default function (components) { 
  return {
    install: (vm) => {
      for (let key in components) {
        let component  = components[key]
        let name = component.name
        vm.component(name, component)
      }
    },
    components 
  } 
}



// WEBPACK FOOTER //
// ./node_modules/vue-mdc-adapter/components/plugin.js